<template>
  <!-- 案件詳細 -->
  <div id="PSGRequestAcceptDetail">
    <div id="container">
      <div class="labelTitle lable">PSG解析 受付</div>
      <div class="button-area"><b-button class="backButton is-primary" @click="back">戻る</b-button></div>
      <div v-if="loadData" id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td><a @click="showDetail(data.receiptNumber)">{{data.receiptNumber}} <b-icon icon="vector-arrange-above"/></a></td>
            </tr>
            <tr>
              <th>検査の種類</th>
              <td>{{data.kind}}<span v-if="data.demo" class="demo"/></td>
            </tr>
            <tr>
              <th>解析方法</th>
              <td>{{data.analysisMethod | choiceFilter(analysisMethodList)}} </td>
            </tr>
            <tr v-if="isWP(data.analysisMethod)">
              <th>いびきセンサー同梱の有無</th>
              <td>{{setSnoreSensorValue(data.snoreSensor)}}</td>
            </tr>
            <tr>
              <th>依頼元</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.client}}</td>
            </tr>
            <tr>
              <th>医療機関</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospital}}</td>
            </tr>
            <tr>
              <th>患者名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patient}}</td>
            </tr>
            <tr>
              <th>申込日</th>
              <td>{{data.applicationDate}}　{{data.applicant}}</td>
            </tr>
            <tr>
              <th>返却希望日</th>
              <td>{{data.returnDate}}<span v-if="data.urgent" class="urgent"/></td>
            </tr>
            <tr v-if="data.urgent">
              <th>お急ぎ便利用理由</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.urgentReason}}</div></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;color:red">{{data.belongsNote}}</td>
            </tr>
            <tr>
              <th v-if="!data.hstRequestId" style="vertical-align:top;">依頼時備考</th>
              <th v-if="data.hstRequestId" style="vertical-align:top;">申送り事項</th>
              <td><textarea v-model="data.applicationDetails.biko" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
            </tr>
            <tr>
              <th>解析担当者<span class="require"/></th>
              <td><input type="text" disabled="disabled" style="width:700px;" class="edit" name="解析担当者" validate="required" v-model="data.analyistName"/><b-button style="margin-left:10px; width:150px; height:27px;" @click="analyistSelectModalActive=true">担当者選択</b-button></td>
            </tr>
            <tr>
              <th>解析期限<span class="require"/></th>
              <td><input type="date" style="width:200px" class="edit" name="解析期限" validate="required" v-model="data.analysisLimit" :min="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
            </tr>
            <tr>
              <th style="vertical-align:top;">備考</th>
              <td><textarea v-model="data.note" maxlength="256" style="resize:vertical;max-width:100%;height:100px;"></textarea></td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <b-button class="receptionistButton is-primary" @click="save">更新</b-button>
          <b-button class="receptionistButton is-primary" @click="receptionist">受付</b-button>
        </div>
      </div>
      <floatingModal name="detail-modal" modalClass="detail-modal" @close="closeDetail" title="" width="640" height="480" top="100px" right="100px">
        <psgRequestDetail v-bind:data="data.applicationDetails" :hstRequestId="data.hstRequestId" :canUpdate="false" :isInternalPsg="true"/>
      </floatingModal>
    </div>
    <b-modal :active.sync="analyistSelectModalActive" has-modal-card class="analysis-modal">
      <analyistSelectModal :selectRole="[role.role_psc, role.role_analysis]" title="解析担当者選択" labelForOrg="解析担当者" @select="setAnalyist"></analyistSelectModal>
    </b-modal>
  </div>
</template>

<script>
import {role} from "@/components/mock/base/const.js";
import {choicesType, psgAnalysisValue} from "@/components/mock/base/const.js";
import floatingModal from "@/components/mock/common/FloatingModal";
import AnalyistSelectModal from "@/components/mock/philips/common/AnalyistSelectModal";
import PSGRequestDetail from "@/components/mock/common/PSGRequestDetail";
export default {
  name: "PSGRequestAcceptDetail",
  methods: {
    back: function () {
      this.$router.push({
        name: "PSGRequestAccept",
        params: { searchConditions: this.searchParams },
      });
    },
    save: function() {
      var excuteApi = this.setPsgTempSavePOST;
      var successCallBack = this.setPsgTempSavePOSTSuccess;
      var errorCallBack = this.setPsgTempSavePOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setPsgTempSavePOST: function(client) {
      var obj = ({
        receiptNumber: this.data.receiptNumber, // 申込みID
        version: this.data.version, // バージョン
        viewType:"受付",
        applicationNote:this.data.applicationDetails.biko, // 依頼内容備考(申送り事項)
        analysisStaffCode: this.data.analyist ? JSON.stringify(this.data.analyist) : "", // 解析担当者コード
        analysisDeadline: this.data.analysisLimit ? this.data.analysisLimit : "", // 解析期限
        receptionNote: this.data.note // 受付備考
      });
      return client.apis.internalPsg.setPsgTempSavePOST({
        body:obj
      });
    },
    setPsgTempSavePOSTSuccess: function(result) {
      this.showSuccess(result)
      this.doSearch();
    },
    setPsgTempSavePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    receptionist: function() {
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit");
      var result = this.selfMadeValidation(elements);
      if(result.isError){
        this.showErrorMessage(result.msg)
      } else {
        var excuteApi = this.setPsgRequestPOST;
        var successCallBack = this.setPsgRequestPOSTSuccess;
        var errorCallBack = this.setPsgRequestPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    setPsgRequestPOST: function(client) {
      var obj = ({
        receiptNumber: this.data.receiptNumber, // 申込みID
        analysisStaffCode: JSON.stringify(this.data.analyist), // 解析担当者コード
        analysisStaffName: this.data.analyistName, // 解析担当者名
        analysisDeadline: this.data.analysisLimit, // 解析期限
        biko: this.data.note, // 備考
        inspectionKind: this.data.kind, // 検査種類
        analysisMethod: this.data.analysisMethod, // 解析方法
        applicationDate: this.data.applicationDate, // 申込日
        hospital: this.data.hospital, // 医療機関名
        client: this.data.client, // 依頼元
        returnDate: this.data.returnDate, // 返却希望日
        version: this.data.version, // バージョン
        applicationNote:this.data.applicationDetails.biko // 依頼内容備考(申送り事項)
      });
      return client.apis.internalPsg.setPsgRequestPOST({
        body:obj
      });
    },
    setPsgRequestPOSTSuccess: function(result) {
      this.showSuccess(result)
      this.back()
    },
    setPsgRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(id) {
      this.isShowDetail = true;
      this.$modal.show('detail-modal')
    },
    closeDetail: function(){
      this.isShowDetail = false;
      this.$modal.hide('detail-modal')
    },
    setAnalyist: function(analyistInfo) {
      this.data.analyist = analyistInfo.id;
      this.data.analyistName = analyistInfo.orgName;
    },
    doSearch: function() {
      var excuteApi = this.getPsgRequestDetailPOST;
      var successCallBack = this.getPsgRequestDetailPOSTSuccess;
      var errorCallBack = this.getPsgRequestDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getPsgRequestDetailPOST: function(client) {
      return client.apis.internalPsg.getPsgRequestDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getPsgRequestDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.loadData = true;
      if (this.data.analysisLimit == "") {
        this.data.analysisLimit = this.data.returnDate.replace(/\//g, "-");
      }
    },
    getPsgRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.back()
    },
    isWP: function(analysisMethod) {
      if(analysisMethod == psgAnalysisValue.WP){
        return true
      }
      return false
    },
    setSnoreSensorValue: function(snoreSensor) {
      var setSnoreSensorValue = snoreSensor ? "有" : "無";
      return setSnoreSensorValue;
    },
  },
  data() {
    var targetNumber = decodeURIComponent(this.$route.query["receiptNumber"]);
    var searchParams = this.$route.params["searchConditions"];
    let analysisMethodList = this.getChoiceList(choicesType.psgMethod, true);
    return {
      role: role,
      choicesType:choicesType,
      data:[],
      targetNumber,
      searchParams,
      analyistSelectModalActive: false,
      isShowDetail: false,
      analysisMethodList: analysisMethodList,
      loadData: false,
      reOpenModal:false
    };
  },
  async mounted() {
    await this.doSearch();
  },
  filters: {
    choiceFilter: function(val, list){
      if(!val) return val
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: { 
    floatingModal:floatingModal,
    analyistSelectModal:AnalyistSelectModal,
    psgRequestDetail:PSGRequestDetail
  }

};
</script>
<style lang="scss" scoped>
.receptionistButton {
    width:100px;
}

table.flowTable,
table.flowTable tr,
table.flowTable td {
    border: 1px solid;
    padding: 0px;
    vertical-align: middle;
}
table.flowTable td {
    width: 40px;
    text-align: center;
}

.delay {
    color: red;
    font-weight: bold; 
}
a {
  text-decoration: underline;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/psg/PSGRequestAcceptDetail.vue